import increase from './increase';
import decrease from './decrease';

export default {
  increase,
  decrease,
};



// WEBPACK FOOTER //
// ./src/actions/number/index.js